export default "__VITE_ASSET__DB_dauf$__"